// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2qv2s","noInteraction":"EventWrapper_noInteraction__1ThB5"};